export default "__VITE_ASSET__BCEK69ru__"